import axios from 'axios';
import { SETTINGS } from '../../config/settings';

const baseURL = SETTINGS.public.urlPartnerSvc;

const apiClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

export default apiClient;
